// extracted by mini-css-extract-plugin
export default {"name":"b4_fT","title":"b4_c1"};